// src/widgets/moderation/LastNewCasesTable/LastNewCasesTable.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { base } from 'routes/ModerationRoutes';
import { Card } from '../Card/Card';
import './LastNewCasesTable.scss';

export type CaseRow = {
  rowKey: string; // ✅ нове
  caseId: number;
  categoryLabel: string;
  contentTypeLabel: string;
  channelTitle?: string;
  channelLink?: string;
  username?: string;
  createdAt: string;
  reportsCnt?: number;
  severity?: 'high' | 'medium' | 'low';
};

type Props = {
  items: CaseRow[];
  onOpenCase: (caseId: number) => void;
};

const sevVariant = (s?: CaseRow['severity']) => {
  if (s === 'high') return 'danger';
  if (s === 'medium') return 'warning';
  if (s === 'low') return 'info';
  return 'default';
};

export const LastNewCasesTable: React.FC<Props> = ({ items, onOpenCase }) => {
  console.log(items);
  return (
    <Card className="md-last" title="Recent Reports">
      <div className="md-last__table">
        <div className="md-last__head">
          <div className="md-last__th">Category</div>
          <div className="md-last__th">Content</div>
          <div className="md-last__th">Channel</div>
          <div className="md-last__th">User</div>
          <div className="md-last__th">Date</div>
          <div className="md-last__th md-last__th--right">Reports</div>
          <div className="md-last__th md-last__th--right">Review</div>
        </div>

        {items.length === 0 ? (
          <div className="md-last__empty">No reports yet.</div>
        ) : (
          items.map((row) => (
            <div key={row.rowKey} className="md-last__row">
              <div className="md-last__td">
                <span>{row.categoryLabel.replaceAll(',', ', ')}</span>
              </div>

              <div className="md-last__td">{row.contentTypeLabel}</div>

              <div className="md-last__td">
                {row.channelLink ? (
                  <a
                    className="md-last__link"
                    href={row.channelLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {row.channelTitle ?? row.channelLink}
                  </a>
                ) : (
                  <span className="md-last__muted">—</span>
                )}
              </div>

              <div className="md-last__td">
                {row.username ?? <span className="md-last__muted">—</span>}
              </div>

              <div className="md-last__td">{row.createdAt}</div>

              <div className="md-last__td md-last__td--right">{row.reportsCnt ?? '—'}</div>

              <div className="md-last__td md-last__td--right">
                <Link
                  to={`${base}/details-queue/${row.caseId}`}
                  className="reports-table__open md-last__btn "
                  type="button"
                >
                  Review
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </Card>
  );
};
